import { Component, OnInit, AfterViewChecked, ElementRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApplicationDataService } from '../../../services/application.service';
import { ApplicantPersonal } from '../../models/applicantpersonal';
import { LabelValue } from '../../models/labelvalue';
import { OtherOccupant } from '../../models/otheroccupant';
import { MaritalStatus } from '../../models/maritalstatus';
import { Pet } from '../../models/pet';
import { PetType } from '../../models/pettype';
import { Router, ActivatedRoute } from '@angular/router';
import { ProspectConfirm } from 'app/models/prospect-confirm';
import { ApplicantPersonalInterface } from '../../interface/applicantpersonal';
import { Property } from '../../models/property';
import { EventEmitterService } from 'services/event-emitter.service';
import { SplashService } from 'services/splash.service';
import { AnalyticsService } from 'services/analytics.service';

@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrls: ['./personal.component.css']
})
export class PersonalComponent implements OnInit, AfterViewChecked {
  @ViewChild('personalInfo', { static: true }) private myScrollContainer: ElementRef;
  errorMessage: string;
  model: ApplicantPersonal;
  maritalStatuses: LabelValue[];
  pets: Pet[];
  months: LabelValue[];
  days: LabelValue[];
  years: LabelValue[];
  petTypes: LabelValue[];
  occupants: OtherOccupant[];
  states: LabelValue[] = [];
  hasChildrenOptions: LabelValue[];
  hasPetOptions: LabelValue[];
  occupantBirthYears: LabelValue[];
  AddAdditionalApplicantKey: number = null;
  AddAdditionalApplicantName: string = null;
  modelProperty: Property;
  splashHTML: string;
  disableSubmitBtn: Boolean = false;
  hasRentableItems: boolean;
  totalApplicationSteps: number = 8;
  showSSN: Boolean = false;
  maskedSSN: string = null;

  @ViewChild('personalForm', { static: true })
  personalForm: NgForm;

  constructor(
    private applicationService: ApplicationDataService,
    public router: Router,
    public route: ActivatedRoute,
    private eventEmitterService: EventEmitterService,
    private splashService: SplashService,
    private readonly analyticsService: AnalyticsService) {
    this.analyticsService.track(
      'HRA Application',
      'Personal Information',
      'Start',
      'Start',
      '',
      this.additionalAnalyticsDetails());
    this.model = new ApplicantPersonal();
    const RentalApplicationKey = localStorage.getItem('RentalApplicationKey');
    const RentalApplicantKey = localStorage.getItem('RentalApplicantKey');

    const AddAdditionalApplicantKey = localStorage.getItem('AddAdditionalApplicantKey');
    const AddAdditionalApplicantName = localStorage.getItem('AddAdditionalApplicantName');

    const correctStatus = localStorage.getItem('CorrectStatus');

    if (correctStatus != "true") {
      localStorage.removeItem('RentalApplicationKey');
      this.analyticsService.track(
        'HRA Application',
        'Personal Information',
        'Stop',
        'Application not in the correct status',
        '/application/dashboard',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/dashboard']);
    }

    if (AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined) {
      this.AddAdditionalApplicantKey = Number(AddAdditionalApplicantKey);
    }

    if (AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined) {
      this.AddAdditionalApplicantName = AddAdditionalApplicantName
    }

    this.eventEmitterService.splashChangeEmitted$.subscribe(res => this.updateSplashHTML(res));
    this.splashService.updateSplash("apply");

    if (RentalApplicationKey !== undefined && RentalApplicationKey !== null &&
      RentalApplicantKey !== undefined && RentalApplicantKey !== null) {

      this.model.RentalApplicationKey = Number(RentalApplicationKey);
      this.model.RentalApplicantKey = Number(RentalApplicantKey);

      this.applicationService.getPersonalInformation(RentalApplicationKey, RentalApplicantKey, AddAdditionalApplicantKey).subscribe(res => this.getPersonalInfo(res),
        res => this.errorMessage = this.applicationService.handleError(res));
    } else {
      this.analyticsService.track(
        'HRA Application',
        'Personal Information',
        'Stop',
        'No rentail application key',
        '/application/basic',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/basic']);
    }
  }

  private additionalAnalyticsDetails(): any {
    try {
      return {
        'NumberOfChildren': this.occupants?.length ?? 0,
        'NumberOFPets': this.pets?.length ?? 0
      };
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  ngOnInit() {
    const rentableItems = localStorage.getItem('hasRentableItems');
    const verifastEnabled = localStorage.getItem('verifastEnabled');
    const hasAncillaryItems = localStorage.getItem('HasAncillaryItems');
    if ((rentableItems && rentableItems === 'true') || (hasAncillaryItems && hasAncillaryItems === 'true')) {
      this.hasRentableItems = true;
      this.totalApplicationSteps = 9;
    }
    if (verifastEnabled && verifastEnabled === 'true') {
      this.totalApplicationSteps++;
    }

    this.getMonths();
    this.getDays();
    this.getYears();
    this.getOccupantBirthYears();
    this.getHasChildrenOptions();
    this.getHasPetOptions();
    this.applicationService.getRentalMaritalStatuses().subscribe(res => this.getMaritalStatuses(res),
      res => this.applicationService.handleError(res))

    this.applicationService.getRentalPetTypes().subscribe(res => this.getPetTypes(res), res => this.applicationService.handleError(res));
    this.getStates();
    const property = JSON.parse(localStorage.getItem('SelectedProperty'));
    if (property != null) {
      this.modelProperty = property[0];
      if ((property[0].min_rent != null && property[0].max_rent != null) && (property[0].min_rent == property[0].max_rent)) {
        this.modelProperty.rent = property[0].min_rent.toLocaleString();
      }
      else if (property[0].min_rent != null && property[0].max_rent != null) {
        this.modelProperty.rent = property[0].min_rent.toLocaleString() + '-$' + property[0].max_rent.toLocaleString()
      }
    }
  }

  updateSplashHTML(res: string) {
    this.splashHTML = res;
  }

  onGetSelfTourConfirmInfo(info: ProspectConfirm) {
    this.model.DLNum = info.LicenseNumber;
    const bday: Date = new Date(info.DateOfBirth);
    // Javascript Month is 0 indexed
    this.model.birthMonth = bday.getMonth() + 1;
    this.model.birthDay = bday.getDate();
    this.model.birthYear = bday.getFullYear();
  }

  getHasChildrenOptions() {
    this.hasChildrenOptions = [];
    this.hasChildrenOptions.push({ label: "Will you have children in the home?", value: null })
    this.hasChildrenOptions.push({ label: "Yes", value: true });
    this.hasChildrenOptions.push({ label: "No", value: false });
  }

  getHasPetOptions() {
    this.hasPetOptions = [];
    this.hasPetOptions.push({ label: "Do you have any pets?", value: null })
    this.hasPetOptions.push({ label: "Yes", value: true });
    this.hasPetOptions.push({ label: "No", value: false });
  }

  getMonths() {
    this.months = [];
    this.months.push({ label: 'January', value: 1 });
    this.months.push({ label: 'February', value: 2 });
    this.months.push({ label: 'March', value: 3 });
    this.months.push({ label: 'April', value: 4 });
    this.months.push({ label: 'May', value: 5 });
    this.months.push({ label: 'June', value: 6 });
    this.months.push({ label: 'July', value: 7 });
    this.months.push({ label: 'August', value: 8 });
    this.months.push({ label: 'September', value: 9 });
    this.months.push({ label: 'October', value: 10 });
    this.months.push({ label: 'November', value: 11 });
    this.months.push({ label: 'December', value: 12 });
  }

  getDays() {
    this.days = [];
    for (let _d = 1; _d <= 31; _d++) {
      this.days.push({ label: _d.toString(), value: _d });
    }
  }

  getYears() {
    const year = new Date().getFullYear();
    this.years = [];
    for (let _y = year; _y >= year - 120; _y--) {
      this.years.push({ label: _y.toString(), value: _y });
    }
  }

  getOccupantBirthYears() {
    const year = new Date().getFullYear();
    this.occupantBirthYears = [];
    for (let _y = year; _y >= year - 18; _y--) {
      this.occupantBirthYears.push({ label: _y.toString(), value: _y });
    }
  }

  ngAfterViewChecked() {
    // this.scrollToBottom();
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollIntoView(false);
    } catch (err) { console.log('error: ' + err); }
  }

  unmaskSSN() {
    this.showSSN = true;
  }

  maskSSN() {
    if (this.model.SSN.length === 9) {
      this.maskedSSN = this.model.SSN.substring(5, 9);
      this.showSSN = false;
    }

  }

  getPersonalInfo(personalInfo: ApplicantPersonal) {
    var tempAppKey = this.model.RentalApplicationKey;
    this.model = personalInfo;
    this.model.RentalApplicationKey = tempAppKey;
    this.occupants = <OtherOccupant[]>personalInfo.Occupants;
    this.pets = <Pet[]>personalInfo.Pets;

    let AddAdditionalApplicantKey = localStorage.getItem('AddAdditionalApplicantKey');
    if (AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined) {
      this.model.CompletedByOther = true;
    }
    else {
      this.model.CompletedByOther = false;
    }

    if (this.model.SSN) {
      this.model.SSN = this.model.SSN.replace(/[^A-Z0-9]/ig, "");
      if (this.model.SSN.length === 9) {
        this.maskedSSN = this.model.SSN.substring(5);
      }
      else {
        this.showSSN = true;
      }
    }
    else {
      this.showSSN = true;
    }

    if (personalInfo.BirthDate) {
      const bday: Date = new Date(personalInfo.BirthDate);
      // Javascript Month is 0 indexed
      this.model.birthMonth = bday.getMonth() + 1;
      this.model.birthDay = bday.getDate();
      this.model.birthYear = bday.getFullYear();
    }

    if (this.occupants.length === 0) {
      this.occupants.push(new OtherOccupant());

      //If this applicant has already submitted personal info
      if (personalInfo.RentalMaritalStatusKey != null) {
        this.model.hasChildren = false;
      }
      else {

        this.model.hasChildren = null;
      }
    }
    else {
      this.occupants.forEach(x=>{
        x.IsDisabled=!(this.model.IsPrimary || this.model.RentalApplicantKey===x.RentalApplicant_RentalApplicantKey)
      })
      this.model.hasChildren = true;
    }

    if (this.pets.length === 0) {
      this.pets.push(new Pet());

      //If this applicant has already submitted personal info
      if (personalInfo.RentalMaritalStatusKey != null) {
        this.model.hasPets = false;
      }
      else {
        this.model.hasPets = null;
      }
    }
    else {
      this.pets.forEach(x=>{
        x.IsDisabled=!(this.model.IsPrimary || this.model.RentalApplicantKey===x.RentalApplicant_RentalApplicantKey)
      })
      this.model.hasPets = true;
    }
  }

  getMaritalStatuses(statuses: MaritalStatus[]) {
    this.maritalStatuses = [];
    for (const status of statuses) {
      this.maritalStatuses.push({ label: status.Title, value: status.RentalMaritalStatusKey });
    }
  }

  disableOccupantDropDown():boolean{
    return this.model.hasChildren && !this.model.IsPrimary
  }

  disablePetDropDown():boolean{
    return this.model.hasPets && !this.model.IsPrimary
  }

  getPetFeeToolTip() {
    return 'We allow up to two pets.';
  }

  cancelEdit() {
    localStorage.removeItem('AddAdditionalApplicantKey');
    localStorage.removeItem('AddAdditionalApplicantName');
    this.analyticsService.track(
      'HRA Application',
      'Personal Information',
      'Stop',
      'Cancelling edit',
      '/application/applicants',
      this.additionalAnalyticsDetails());
    this.router.navigate(['/application/applicants']);
  }

  getPetTypes(types: PetType[]) {
    this.petTypes = [];
    for (const type of types) {
      this.petTypes.push({ label: type.Title, value: type.RentalPetTypesKey });
    }
  }

  getStates() {
    this.states.push({ label: 'AK', value: 'AK' });
    this.states.push({ label: 'AL', value: 'AL' });
    this.states.push({ label: 'AR', value: 'AR' });
    this.states.push({ label: 'AZ', value: 'AZ' });
    this.states.push({ label: 'CA', value: 'CA' });
    this.states.push({ label: 'CO', value: 'CO' });
    this.states.push({ label: 'CT', value: 'CT' });
    this.states.push({ label: 'DE', value: 'DE' });
    this.states.push({ label: 'FL', value: 'FL' });
    this.states.push({ label: 'GA', value: 'GA' });

    this.states.push({ label: 'HI', value: 'HI' });
    this.states.push({ label: 'IA', value: 'IA' });
    this.states.push({ label: 'ID', value: 'ID' });
    this.states.push({ label: 'IL', value: 'IL' });
    this.states.push({ label: 'IN', value: 'IN' });
    this.states.push({ label: 'KS', value: 'KS' });
    this.states.push({ label: 'KY', value: 'KY' });
    this.states.push({ label: 'LA', value: 'LA' });
    this.states.push({ label: 'MA', value: 'MA' });
    this.states.push({ label: 'MD', value: 'MD' });

    this.states.push({ label: 'ME', value: 'ME' });
    this.states.push({ label: 'MI', value: 'MI' });
    this.states.push({ label: 'MN', value: 'MN' });
    this.states.push({ label: 'MO', value: 'MO' });
    this.states.push({ label: 'MS', value: 'MS' });
    this.states.push({ label: 'MT', value: 'MT' });
    this.states.push({ label: 'NE', value: 'NE' });
    this.states.push({ label: 'NH', value: 'NH' });
    this.states.push({ label: 'NJ', value: 'NJ' });
    this.states.push({ label: 'NM', value: 'NM' });

    this.states.push({ label: 'NV', value: 'NV' });
    this.states.push({ label: 'NY', value: 'NY' });
    this.states.push({ label: 'NC', value: 'NC' });
    this.states.push({ label: 'ND', value: 'ND' });
    this.states.push({ label: 'OH', value: 'OH' });
    this.states.push({ label: 'OK', value: 'OK' });
    this.states.push({ label: 'OR', value: 'OR' });
    this.states.push({ label: 'PA', value: 'PA' });
    this.states.push({ label: 'RI', value: 'RI' });
    this.states.push({ label: 'SC', value: 'SC' });

    this.states.push({ label: 'SD', value: 'SD' });
    this.states.push({ label: 'TN', value: 'TN' });
    this.states.push({ label: 'TX', value: 'TX' });
    this.states.push({ label: 'UT', value: 'UT' });
    this.states.push({ label: 'VT', value: 'VT' });
    this.states.push({ label: 'VA', value: 'VA' });
    this.states.push({ label: 'WA', value: 'WA' });
    this.states.push({ label: 'WI', value: 'WI' });
    this.states.push({ label: 'WV', value: 'WV' });
    this.states.push({ label: 'WY', value: 'WY' });
  }

  onAddOccupantClick() {
    this.occupants.push(new OtherOccupant());
  }

  onRemoveOccupantClick(occupant: OtherOccupant) {
    if (this.model.hasChildren && this.occupants.length == 1) {
      //
    }
    else {
      const index = this.occupants.indexOf(occupant);
      this.occupants.splice(index, 1);
    }
  }

  onAddPetClick() {
    if (this.pets.length < 2) {
      this.pets.push(new Pet());
    }
    else {
      this.errorMessage = 'Only two pets are allowed.';
    }
  }

  onRemovePetClick(pet: Pet) {
    if (this.model.hasPets && this.pets.length == 1) {
      //
    }
    else {
      const index = this.pets.indexOf(pet);
      this.pets.splice(index, 1);
    }
  }

  removeUnusedOccupantsAndPets() {
    this.disableSubmitBtn = true;
    if (this.occupants.length === 1) {
      if (this.occupants[0].Name === '' && this.occupants[0].BirthYear === null && !this.model.hasChildren) {
        this.onRemoveOccupantClick(this.occupants[0]);
      }
    }
    if (this.pets.length === 1) {
      if (this.pets[0].Breed === '' && this.pets[0].Weight === null && this.pets[0].RentalPetTypesKey === 0 && !this.model.hasPets) {
        this.onRemovePetClick(this.pets[0]);
      }
    }
    this.onSubmit();
  }

  forceAtLeastOneOccupant() {
    if (this.model.hasChildren) {
      if (this.occupants.length === 0) {
        this.occupants.push(new OtherOccupant());
      }
    }
  }

  forceAtLeastOnePet() {
    if (this.model.hasPets) {
      if (this.pets.length === 0) {
        this.pets.push(new Pet());
      }
    }
  }

  onSubmit() {
    const bdayString = this.model.birthMonth + '/' + this.model.birthDay + '/' + this.model.birthYear;
    this.model.BirthDate = new Date(bdayString);
    if (this.personalForm.valid) {
      if (!this.model.hasChildren) {
        this.occupants = [];
      }
      if (!this.model.hasPets) {
        this.pets = [];
      }
      if (this.pets.length > 0) {
        for (const pet of this.pets) {
          let stringNumber = String(pet.Weight);
          stringNumber = stringNumber.replace(/[^\d.]/g, '');
          pet.Weight = Number(stringNumber);

        }
      }
      this.model.SSN = `${this.model.SSN.substring(0, 3)}-${this.model.SSN.substring(3, 5)}-${this.model.SSN.substring(5)}`;
      this.applicationService.updatePersonalInformation(this.model, this.occupants, this.pets)
        .subscribe((res: ApplicantPersonalInterface) => this.onUpdateSuccess(res),
          res => {
            this.disableSubmitBtn = false;
            this.errorMessage = this.applicationService.handleError(res)
          });
    } else {
      this.disableSubmitBtn = false;
      this.errorMessage = 'Please fill in all required information or remove unneeded occupants and pets.';
    }
  }

  onUpdateSuccess(personalInfo: ApplicantPersonal) {
    this.analyticsService.track(
      'HRA Application',
      'Personal Information',
      'Stop',
      'Sending to residency',
      '/application/residency',
      this.additionalAnalyticsDetails());
    this.router.navigate(['/application/residency'], { fragment: 'rentalhistory' });
  }


  // Do Not Delete.  ngFor will break on add remove without.
  listTrack(o) {
    return o;
  }
}
